import { KalturaMediaAsset } from '@kaltura-ott/ott-client-types/api/types';
import { map } from 'rxjs/operators';

import { getAssetsByChannelId } from './asset';
import { assetToLoginAsset } from './asset.helper';

export const getLoginAssets = (channelId: number) => {
  return getAssetsByChannelId({ channelId, pageIndex: 1, pageSize: 1000 }).pipe(
    map((assetList) => {
      if (!assetList || assetList?.objects?.length === 0) return [];
      const assets = assetList.objects;
      return assets?.map((asset) => assetToLoginAsset(asset as KalturaMediaAsset));
    }),
  );
};
